import { useEffect, useState } from 'react';
import { api } from '../../api';
import { SectionTitle, RunButton } from '../UI';

export default function LogsTab() {
  const [lines, setLines] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  async function loadLogs() {
    setLoading(true);
    setError('');
    try {
      const data = await api.getLogs(200);
      setLines(data.lines || []);
    } catch (err) {
      setError(err.message || 'Failed to load logs');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadLogs();
  }, []);

  return (
    <div>
      <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '24px', fontWeight: '700', marginBottom: '6px' }}>Logs</h1>
          <p style={{ fontSize: '14px', color: 'var(--text-3)' }}>
            Recent backend logs and errors from the running panel.
          </p>
        </div>
        <RunButton onClick={loadLogs}>{loading ? 'Refreshing...' : 'Refresh Logs'}</RunButton>
      </div>

      <SectionTitle>Recent entries</SectionTitle>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '18px' }}>
        {error && <div style={{ color: 'var(--poor)', marginBottom: '12px', fontFamily: 'var(--font-mono)', fontSize: '12px' }}>{error}</div>}
        {!error && lines.length === 0 && !loading && <div style={{ color: 'var(--text-3)' }}>No logs yet.</div>}
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px', lineHeight: 1.6, color: 'var(--text-2)', fontFamily: 'var(--font-mono)', maxHeight: '70vh', overflow: 'auto' }}>
          {lines.join('\n')}
        </pre>
      </div>
    </div>
  );
}
